var ResponsiveTable = {
	init:function(){
		
		$(".wp-block-table").each(function(){
			
			var _table = $(this);
			
			_table.find("thead th").each(function(){
				var _col_id = $(this).index();
				var _col_name = $(this).html();
				
				_table.find("tbody td").each(function(){
					if($(this).index() == _col_id){
						$(this).attr("data-label", _col_name);
					}
				})
			}) 
		});

	}
}

$(window).load(function(){
	if($(".wp-block-table").length){
		ResponsiveTable.init();
	}
})